// animations.ts
var pulsate = {
  "@keyframes pulsate": {
    "0%": { boxShadow: "0px 0px 1px 4px rgba(89, 183, 255, .3)" },
    "75%": { boxShadow: "0px 0px 1px 9px rgba(89, 183, 255, 0)" },
    "100%": { boxShadow: "0px 0px 1px 4px rgba(89, 183, 255, 0)" }
  }
};
export {
  pulsate
};
